module.exports = __webpack_public_path__ + "static/media/casper_icon.02ad8b96.svg";